import { render, staticRenderFns } from "./SelectedGoalsAreas.vue?vue&type=template&id=b243fcfa&scoped=true"
import script from "./SelectedGoalsAreas.vue?vue&type=script&lang=js"
export * from "./SelectedGoalsAreas.vue?vue&type=script&lang=js"
import style0 from "./SelectedGoalsAreas.vue?vue&type=style&index=0&id=b243fcfa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b243fcfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b243fcfa')) {
      api.createRecord('b243fcfa', component.options)
    } else {
      api.reload('b243fcfa', component.options)
    }
    module.hot.accept("./SelectedGoalsAreas.vue?vue&type=template&id=b243fcfa&scoped=true", function () {
      api.rerender('b243fcfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/components/SelectedGoalsAreas.vue"
export default component.exports